export const skillCategories = [
  {
    name: "Languages",
    icon: "{ }",
    skills: [
      { name: "Python", icon: "SiPython" },
      { name: "JavaScript", icon: "SiJavascript" },
      { name: "Java", icon: "SiOpenjdk" },
      { name: "C / C++", icon: null },
      { name: "SQL", icon: "SiPostgresql" },
      { name: "PHP", icon: null },
    ],
  },
  {
    name: "Frontend",
    icon: "</>",
    skills: [
      { name: "React", icon: "SiReact" },
      { name: "HTML5", icon: "SiHtml5" },
      { name: "CSS3", icon: "SiCss3" },
      { name: "Tailwind CSS", icon: "SiTailwindcss" },
      { name: "Vite", icon: "SiVite" },
    ],
  },
  {
    name: "Backend & Databases",
    icon: "⬡",
    skills: [
      { name: "Node.js", icon: "SiNodedotjs" },
      { name: "MySQL", icon: "SiMysql" },
    ],
  },
  {
    name: "Tools",
    icon: "⚙",
    skills: [
      { name: "Git", icon: "SiGit" },
      { name: "GitHub", icon: "SiGithub" },
      { name: "VS Code", icon: "SiVisualstudiocode" },
      { name: "Postman", icon: "SiPostman" },
    ],
  },
  {
    name: "Concepts",
    icon: "◈",
    skills: [
      { name: "REST APIs", icon: null },
      { name: "Data Structures", icon: null },
      { name: "Algorithms", icon: null },
      { name: "OOP", icon: null },
      { name: "Responsive Design", icon: null },
      { name: "Version Control", icon: null },
    ],
  },
];
